import { useCurrentUser } from '../../contexts/UserContext';
import { useContentTechDomains } from './useContentTechDomains';
import { useLoadedDocument } from './useLoadedDocument';

/**
 * Whether the current user may open a new inline comment thread on the loaded
 * content. Reviewer-only and draft-only; reading existing threads is not gated
 * by this. Returns false while no document is loaded.
 */
export function useCanStartCommentThread(): boolean {
  const { canStartCommentThreadForContent } = useCurrentUser();
  const { mainTechDomain, techDomains } = useContentTechDomains();
  const document = useLoadedDocument();

  if (!document) return false;

  return canStartCommentThreadForContent(document.kind, mainTechDomain, techDomains);
}
